import LineGradient from "../components/LineGradient";
import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";

const serviceData = [
  {
    id: 1,
    title: "Modern Templates",
    description:
      "Our professionally designed templates are built for speed, responsiveness, and customization, ensuring a polished online presence for your business.",
    bgColor: "bg-blue",
  },
  {
    id: 2,
    title: "AI Solutions",
    description:
      "Enhance your business with AI-powered tools, including chatbots, recommendation systems, and predictive analytics tailored to your specific needs.",
    bgColor: "bg-red",
  },
  {
    id: 3,
    title: "Custom Development",
    description:
      "Need something unique? Our team offers custom development services to build tailored solutions that align with your business objectives.",
    bgColor: "bg-yellow",
  },
];

const Services = () => {
  const isAboveLarge = useMediaQuery("(min-width: 1060px)");

  return (
    <section id="services" className="pt-10 pb-24">
      {/* HEADER AND IMAGE SECTION */}
      <div className="md:flex md:justify-between md:gap-16 mt-32">
        <motion.div
          className="md:w-1/3"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="font-playfair font-semibold text-4xl mb-5">
            OUR <span className="text-red">SERVICES</span>
          </p>
          <LineGradient width="w-1/3" />
          <p className="mt-10 mb-7">
            We provide a range of professional services tailored to meet your
            business needs, from modern templates to AI-powered integrations.
          </p>
        </motion.div>

        {/* Image Wrapper */}
        <motion.div
          className="mt-16 md:mt-0 relative z-0 mx-auto w-full max-w-[400px]"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div
            className={`relative ${
              isAboveLarge
                ? "ml-20 before:absolute before:-top-10 before:-left-10 before:w-full before:h-full before:border-2 before:border-blue before:z-[-1]"
                : ""
            }`}
          >
            <img
              alt="services"
              className="z-10 w-full"
              src="assets/skills-image.png"
            />
          </div>
        </motion.div>
      </div>

      {/* SERVICES SECTION */}
      <div className="md:flex md:justify-between mt-16 gap-32">
        {serviceData.map(({ id, title, description, bgColor }, index) => (
          <motion.div
            key={id}
            className="md:w-1/3 mt-10"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
          >
            <div className="relative h-32">
              <div className="z-10">
                <p className="font-playfair font-semibold text-5xl">
                  {`0${id}`}
                </p>
                <p className="font-playfair font-semibold text-3xl mt-3">
                  {title}
                </p>
              </div>
              <div
                className={`w-1/2 md:w-3/4 h-32 ${bgColor} absolute right-0 top-0 z-[-1]`}
              />
            </div>
            <p className="mt-5">{description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
